import { useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfMaintanenceReport } from 'src/database';
import api from 'src/services/api';

export const useMaintanenceReportsController = () => {
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState(false);
	const [maintanenceReportData, setMaintanenceReportData] = useState<ModelOfMaintanenceReport[]>([]);

	useEffect(() => {
		getMaintanenceReportData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userAgencyId]);

	const getMaintanenceReportData = () => {
		setLoading(true);
		api.get(`maintanenceData/${userAgencyId}`)
			.then(response => {
				setMaintanenceReportData(response.data.VEICULOS);
				setLoading(false);
			})
			.catch(err => {
				console.log(err);
				setLoading(false);
			});
	};

	const generateMaintanenceReport = (reportData: ModelOfMaintanenceReport[]) => {
		api.post('maintanenceReport', { VEICULOS: reportData }, { responseType: 'arraybuffer' })
			.then(response => {
				let blob = new Blob([response.data], {
					type: 'application/pdf',
				});

				let url = window.URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.href = url;
				link.download = 'file.pdf';
				window.open(link.href);

				setTimeout(() => {
					window.URL.revokeObjectURL(url);
				}, 100);
				setLoading(false);
			})
			.catch(err => {
				console.log(err);
			});
	};

	return {
		getMaintanenceReport: {
			loading,
			maintanenceReportData,
		},
		handleMaintanenceReport: {
			generateMaintanenceReport,
		},
	};
};
